import {ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {AlertsComponent, LoadIndicatorComponent} from '@ratespecial/core';
import {RouterOutlet} from '@angular/router';
import {IAppConfig, PROJECT_CONFIG} from 'src/app/project-config';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterOutlet,
    AlertsComponent,
    LoadIndicatorComponent,
  ],
})
export class AppComponent implements OnInit {
  private config = inject<IAppConfig>(PROJECT_CONFIG);
  private titleService = inject(Title);

  ngOnInit() {
    this.titleService.setTitle(this.config.appName);
  }
}
